import { render, staticRenderFns } from "./Submit.vue?vue&type=template&id=32bff1ed"
import script from "./Submit.vue?vue&type=script&lang=js"
export * from "./Submit.vue?vue&type=script&lang=js"
import style0 from "./Submit.vue?vue&type=style&index=0&id=32bff1ed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports